<template>
  <div>
    <div class="info_headings">
      {{ $t('Email_Us') }}
    </div>
    <div class="info_block">
      <v-form ref="form" v-model="form.valid" lazy-validation>
        <v-text-field
          v-model="form.name"
          :label="$t('Name')"
          :rules="form.nameRules"
          required
          :disabled="submitted"
        />
        <v-text-field
          v-model="form.phone"
          :label="$t('Phone_optional')"
          :rules="form.phoneRules"
          required
          :disabled="submitted"
        />
        <v-text-field
          v-if="contactFormFieldsAllowed.zip"
          v-model="form.zip"
          type="number"
          :label="$t('Form_zip')"
          :rules="form.zipRules"
          required
          :disabled="submitted"
        />
        <v-text-field
          v-if="contactFormFieldsAllowed.birthyear"
          v-model="form.birthyear"
          type="number"
          :label="$t('Form_birthyear')"
          :disabled="submitted"
        />
        <v-text-field
          v-model="form.email"
          :label="$t('Email')"
          :rules="form.emailRules"
          required
          :disabled="submitted"
        />
        <v-text-field
          v-if="contactFormFieldsAllowed.message"
          v-model="form.message"
          :label="$t('Message')"
          :rules="form.messageRules"
          required
          :disabled="submitted"
        />
        <v-checkbox
          class="consent"
          v-model="form.consent"
          :rules="form.consentRules"
          color="primary"
          required
          :disabled="submitted"
        >
          <template v-slot:label>
            <markdown :content="$t('Form_consent')"/>
          </template>
        </v-checkbox>
        <v-btn
          id="unit-single-contact-form-submit-button"
          class="primary"
          :disabled="submitting || submitted"
          @click="submitContactForm"
        >
          {{ !submitted ? $t('SEND') : $t('Form_sent') }}
          <v-icon v-if="getThemedVar('nextButtonIcon', '')" right>
            {{ getThemedVar('nextButtonIcon', '') }}
          </v-icon>
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { disabled } from 'express/lib/application';

export default {
  name: 'ContactForm',
  data() {
    return {
      form: {
        valid: true,
        name: null,
        nameRules: [
          v => !!v || this.$t('Name_is_required'),
        ],
        phone: null,
        phoneRules: [
          v => !!v || this.$t('Phone_is_required'),
        ],
        zip: null,
        zipRules: [
          v => !!v || this.$t('Zip_is_required'),
        ],
        birthyear: null,
        email: null,
        emailRules: [
          v => !!v || this.$t('E_mail_is_required'),
          v => /.+@.+/.test(v) || this.$t('E_mail_must_be_valid'),
        ],
        message: null,
        messageRules: [
          v => !!v || this.$t('Message_is_required'),
        ],
        attachCheckbox: false,
        attachCheckboxLabel: this.$t('Attach_saved_units', { amount: 3 }), // this.$t('Attach_3_saved_units'),
        consent: false,
        consentRules: [
          v => !!v || this.$t('Form_consent_required'),
        ],
      },
      submitting: false,
      submitted: false,
    };
  },
  computed: {
    ...mapGetters('service', ['getThemedVar', 'contactFormFieldsAllowed']),
    ...mapGetters('units', ['currentUnit', 'favourites']),
  },
  methods: {
    disabled,
    submitContactForm() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.submitting = true;

      this.$analytics.fbq.event('Lead');

      this.$store
        .dispatch('project/sendQuestion', {
          form: this.form,
          order: this.$route.params.order,
          favouriteUnits: this.favourites
            .filter(v => v)
            .map(({ name }) => name)
            .join(', '),
        })
        .then(() => {
          this.submitting = false;
          this.submitted = true;
          this.$refs.form.reset();
        });
    },
  },
};
</script>

<style lang="scss">
.consent p {
  margin-bottom: 0;
  font-size: 15px;
}
</style>
